import { TYPES } from "./bailiff_job.type";

const initState = {
  bailiffJobAll: null,
  bailiffJobOpenAdd: false,
  bailiffJobOpenEdit: false,
  bailiffJobOpenPayment: false,
  bailiffJobSelected: null,
  bailiffJobSearch: "",
  //
  bailiffJobDetail: null,
  bailiffJobBanks: [],
  //
  bailiffJobPreview: null,
  //
  bailiffJobExtractingCount: 0,
};

const bailiffJobReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_BAILIFF_JOB_BANKS:
      return {
        ...state,
        bailiffJobBanks: payload,
      };

    case TYPES.SET_BAILIFF_JOB_OPEN_PAYMENT:
      return {
        ...state,
        bailiffJobOpenPayment: payload,
      };

    case TYPES.SET_BAILIFF_JOB_ALL:
      return {
        ...state,
        bailiffJobAll: payload,
      };

    case TYPES.SET_BAILIFF_JOB_OPEN_ADD:
      return {
        ...state,
        bailiffJobOpenAdd: payload,
      };

    case TYPES.SET_BAILIFF_JOB_OPEN_EDIT:
      return {
        ...state,
        bailiffJobOpenEdit: payload,
      };

    case TYPES.SET_BAILIFF_JOB_SELECTED:
      return {
        ...state,
        bailiffJobSelected: payload,
      };

    case TYPES.SET_BAILIFF_JOB_SEARCH:
      return {
        ...state,
        bailiffJobSearch: payload,
      };

    //
    case TYPES.SET_BAILIFF_JOB_DETAIL:
      return {
        ...state,
        bailiffJobDetail: payload,
      };
    case TYPES.SET_BAILIFF_JOB_PREVIEW:
      return {
        ...state,
        bailiffJobPreview: payload,
      };

    case TYPES.SET_BAILIFF_JOB_EXTRACTING_COUNT:
      return {
        ...state,
        bailiffJobExtractingCount: payload,
      };

    default:
      return state;
  }
};

export default bailiffJobReducer;
